export default __webpack_public_path__ + "static/media/accueil.4e901249.jpg";